import { createSelector } from 'reselect';

const selectPinCodes = (state: any) => state.pinCodes;


export const selectPinCodeCurrentItem = createSelector([selectPinCodes], (pinCodes) => pinCodes.current);

export const selectPinCodesListItems = createSelector([selectPinCodes], (pinCodes) => pinCodes.list);

export const selectPinCodeItemById = (itemId: any) =>
    createSelector(selectPinCodesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectPinCodeQueryItems = createSelector([selectPinCodes], (pinCodes) => pinCodes.query);

export const selectPinCodeCreatedItem = createSelector([selectPinCodes], (pinCodes) => pinCodes.create);

export const selectPinCodeUpdatedItem = createSelector([selectPinCodes], (pinCodes) => pinCodes.update);

export const selectPinCodeReadItem = createSelector([selectPinCodes], (pinCodes) => pinCodes.read);

export const selectPinCodeDeletedItem = createSelector([selectPinCodes], (pinCodes) => pinCodes.delete);

export const selectPinCodeSearchedItems = createSelector([selectPinCodes], (pinCodes) => pinCodes.search);

export const selectPinCodeItemsCount = createSelector([selectPinCodes], (pinCodes) => pinCodes.count);

export const selectPinCodeItemsFilter = createSelector([selectPinCodes], (pinCodes) => pinCodes.filter);